import { Box, Typography } from "@mui/material"
import TabelaFaturas from "./components/tabelaFaturas"

const FinanceiroBody = () => {
    return <Box sx={{pt: 2}}>
        <Typography color="warning" variant="h5">Histórico de Faturas</Typography>
        <Typography variant="subtitle2">Aqui você visualiza todas as faturas</Typography>
        <TabelaFaturas/>
    </Box>
}
export default FinanceiroBody